import DocTemplate from "./DocTemplate";

export default DocTemplate;
